import { Injectable } from "@angular/core";
import { SessionContextService } from "../context/session-context.service";
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
} from "@angular/router";

@Injectable({
  providedIn: "root",
})
export class AuthGuard {
  constructor(
    private _router: Router,
    private readonly _sessionContext: SessionContextService
  ) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    const claim: string = next.data.claim;

    if (
      this._sessionContext.sessionUser &&
      (this._sessionContext.sessionUser.role === "Administrador" ||
        this._sessionContext.sessionUser.lsClaimTypes.includes(claim))
    ) {
      return true;
    } else {
      localStorage.setItem("url", state.url);
      return this.goToHome();
    }
  }

  private goToHome() {
    this._router.navigate([""]);
    return false;
  }
}
